module.exports = __webpack_public_path__ + "h5/img/summer-title3-1.09997615.png";